<template>
    <div class="user-import-summary-card">
        <div class="form-row">
            <div class="form-row__col">
                <form-input
                    :name="`users-to-be-imported[${index}][internal_id]`"
                    v-model="user.internal_id"
                >{{ trans('users.label.internal_id') }}</form-input>
            </div>

            <div class="form-row__col">
                <label class="label">{{ trans('users.label.gender') }}</label>
                <select
                    v-model="user.gender"
                    class="form-select"
                    :name="`users-to-be-imported[${index}][gender]`"
                    :class="[{'form-select--error': errors[`users-to-be-imported.${index}`] && errors[`users-to-be-imported.${index}.gender`]}]"
                >
                    <option>{{ trans('users.label.select') }}</option>
                    <option value="male">{{ trans('users.label.male') }}</option>
                    <option value="female">{{ trans('users.label.female') }}</option>
                    <option value="other">{{ trans('users.label.other') }}</option>
                </select>
            </div>

            <div class="form-row__col">
                <label class="label">{{ trans('users.label.title') }}</label>
                <input
                    v-model="user.title"
                    class="input"
                    :name="`users-to-be-imported[${index}][title]`"
                    type="text"
                />
            </div>
        </div>

        <div class="form-row">
            <div class="form-row__col">
                <form-input
                    :name="`users-to-be-imported[${index}][firstname]`"
                    v-model="user.firstname"
                    :required="true"
                    :error="errors[`users-to-be-imported.${index}.firstname`]"
                >{{ trans('users.label.firstname') }}</form-input>
            </div>

            <div class="form-row__col">
                <form-input
                    :name="`users-to-be-imported[${index}][lastname]`"
                    v-model="user.lastname"
                    :required="true"
                    :error="errors[`users-to-be-imported.${index}.lastname`]"
                >{{ trans('users.label.lastname') }}</form-input>
            </div>

            <div class="form-row__col">
                <form-input
                    :name="`users-to-be-imported[${index}][email]`"
                    v-model="user.email"
                    read-only
                    :required="true"
                    :error="errors[`users-to-be-imported.${index}.email`]"
                >{{ trans('users.label.email') }}</form-input>
            </div>
        </div>

        <div class="form-row">
            <div class="form-row__col form-row__col--one-third" v-for="(field, fieldIndex) in user.specificUserFields" :key="field.name">
                <form-input
                    :name="`users-to-be-imported[${index}][specific_user_fields][${{fieldIndex}}`"
                    v-model="field.value"
                    :required="field.required === 'true'"
                    :error="errors[`users-to-be-imported.${index}.specificUserFields.${fieldIndex}.value`]"
                >
                    {{ field.name }}
                </form-input>
            </div>
        </div>

        <div class="form-row" v-show="user.similarUsers.length">
            <div class="form-row__col">
                <label class="label label--required">{{ trans('users.label.action') }}</label>
                <select
                    v-model="user.type"
                    :class="['form-select', {'form-select--error': errors[`users-to-be-imported.${index}.type`]}]"
                    :name="`users-to-be-imported[${index}][type]`"
                    @change="resetHiddenFields()"
                >
                    <option value="new">{{ trans('users.label.create_new_user') }}</option>
                    <option value="map">{{ trans('users.label.map_user') }}</option>
                </select>
                <span class="invalid-feedback" v-if="errors[`users-to-be-imported.${index}.type`]">
                    <strong>{{ errors[`users-to-be-imported.${index}.type`][0] }}</strong>
                </span>
            </div>

            <div class="form-row__col">
                <div v-show="user.type == 'map'">
                    <label class="label label--required">{{ trans('users.label.users_to_map') }}</label>
                    <select
                        v-model="user.mapToUser"
                        class="form-select"
                        :name="`users-to-be-imported[${index}][map-to-user]`"
                    >
                        <option
                            v-for="similarUser in user.similarUsers"
                            :key="similarUser.id"
                            :value="similarUser.id"
                        >{{ similarUserInformation(similarUser) }}</option>
                    </select>
                </div>
            </div>

            <div class="form-row__col">
                <div v-show="user.type == 'map'">
                    <label class="label label--required">{{ trans('users.label.map_option') }}</label>
                    <select
                        v-model="user.mapAction"
                        class="form-select"
                        :name="`users-to-be-imported[${index}][map-action]`"
                    >
                        <option value="update">{{ trans('users.label.update_user') }}</option>
                        <option value="keep">{{ trans('users.label.keep_user') }}</option>
                        <option value="only-update">{{ trans('users.label.update_user_no_assign') }}</option>
                    </select>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { EventBus } from '../eventbus.js';

export default {
    model: {
        prop: 'usersToBeImported',
        event: 'update'
    },

    props: {
        user: Object,
        index: Number,
        errors: Object,
        usersToBeImported: Array,
        sharedEmail: String
    },

    data() {
        return {
            emailIsEmpty: this.usersToBeImported[this.index].email == ''
        };
    },

    methods: {
        similarUserInformation(similarUser) {
            return (
                (similarUser.internal_id
                    ? similarUser.internal_id + ' - '
                    : '') +
                (similarUser.gender
                    ? this.trans('users.label.' + similarUser.gender) + ' '
                    : '') +
                ' ' +
                similarUser.full_name +
                ' - ' +
                similarUser.email
            );
        },

        mapSharedEmail(email) {
            if (this.emailIsEmpty) {
                this.usersToBeImported[this.index].email = email;
            }
        },

        resetHiddenFields() {
            this.usersToBeImported[this.index].mapAction = 'update';
        }
    },

    mounted() {
        EventBus.$on('setSharedEmail', email => this.mapSharedEmail(email));
    }
};
</script>
